/**
 * Part of MOOL-417 was to make this `DealerLocatorModal` a common component; however,
 * `@dmm/react-common-components` does not currently support [React] functional components,
 * until it does, the component will live in the `portal-react-boattrader` project.
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import './styles.css';
import Modal from '../Modal';
import ContactPage from './ContactPage';
import LocatorBody from './LocatorBody';
import LocatorHeader from './LocatorHeader';
import dealerLocatorModalHelper from '../../utils/dealerLocatorModalHelper';
import { ENGLISH_LOCALES } from '../../constants';

// import { setModalEvent } from '../../store/actions/dataLayer';
// const MODAL_TYPE = {
//   dealer: {
//     type: 'dealer',
//     trackingLabel: 'locate dealer'
//   }
// };

// TODO - once we have a title for all languages, remove this
export const shouldContactTitleHide = (locale) => {
  const isEnglishLocale = ENGLISH_LOCALES.includes(locale);
  return isEnglishLocale ? '' : 'hide-contact-title';
};

const DealerLocatorModal = ({
  device,
  hideModal,
  isOpen,
  oemDetails,
  oemDealers,
  setOemDealers,
  dealerIndex,
  setDealerIndex,
  listing,
  isWorking,
  postalCode,
  setPostalCode,
  origin,
  contactFormTitle,
  locale
}) => {
  const [pageIndex, setPageIndex] = useState(0);
  const type = 'dealer';

  const helper = dealerLocatorModalHelper({
    pageIndex,
    oemDealers,
    oemDetails,
    setOemDealers,
    setPageIndex,
    setPostalCode
  });

  const closeModal = () => {
    // setModalEvent('close', MODAL_TYPE[type].trackingLabel);
    hideModal();
    setDealerIndex(undefined);
    helper.goToPageIndex(0);
  };

  useEffect(async () => {
    if (isOpen && !oemDealers) {
      await helper.fetchDealers();
    }
    // setModalEvent('open', MODAL_TYPE[type].trackingLabel);
  });

  return (
    <Modal
      contentLabel={`${oemDetails.brandName} Dealer Modal`}
      injectedStyles={{
        content: {
          background: 'none',
          border: 'none'
        },
        overlay: { background: '#333333E5' }
      }}
      isOpen={isOpen}
      onRequestClose={closeModal}
      portalClassName="dealer-locator-modal"
    >
      <div
        className={`modal-container origin-${origin} ${shouldContactTitleHide(
          locale
        )}`}
        id="dealer-locator-modal"
      >
        {(dealerIndex > -1 && oemDealers[dealerIndex] && (
          <div className="info-container" id="info-container">
            <ContactPage
              type={type}
              setDealerIndex={setDealerIndex}
              closeModal={closeModal}
              dealer={oemDealers[dealerIndex]}
              listing={listing}
              isWorking={isWorking}
              postalCode={postalCode}
              oemDetails={oemDetails}
              contactFormTitle={contactFormTitle}
            />
          </div>
        )) || (
          <div className="locator-container" id="locator-container">
            <LocatorHeader
              oemTerm={oemDetails.brandName}
              fetchDealers={helper.fetchDealers}
              inputPostalCode={postalCode}
              closeModal={closeModal}
            />
            <LocatorBody
              device={device}
              helper={helper}
              pageIndex={pageIndex}
              setDealerIndex={setDealerIndex}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

DealerLocatorModal.propTypes = {
  device: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  oemDetails: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  isWorking: PropTypes.bool.isRequired,
  origin: PropTypes.string,
  contactFormTitle: PropTypes.string,
  locale: PropTypes.string,

  // internally from 'DealerLocator' component
  oemDealers: PropTypes.any,
  setOemDealers: PropTypes.func,
  dealerIndex: PropTypes.any,
  setDealerIndex: PropTypes.func,
  postalCode: PropTypes.any,
  setPostalCode: PropTypes.func
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      // setModalEvent,
    },
    dispatch
  )
)(DealerLocatorModal);
